import {
  RMSPalette,
  amplitudePalette,
  gasOilSaturationPalette,
  hEfficiencyPalette,
  reserveDensityPalette,
  sandinessPalette,
  totalThicknessPalette,
} from '../../constants'
import { ObjectKeys } from '../helpers'

export const palette = {
  paletteRMS: RMSPalette,
  paletteAmplitude: amplitudePalette,
  totalThicknessPalette,
  hEfficiencyPalette,
  gasOilSaturationPalette,
  reserveDensityPalette,
  sandstonePalette: sandinessPalette,
}

const Palette = ObjectKeys(palette)
export type PaletteType = (typeof Palette)[number]

export const gridToPalette = [
  /* 0 */ undefined,
  /* 1 */ RMSPalette,
  /* 2 */ amplitudePalette,
  /* 3 */ totalThicknessPalette,
  /* 4 */ hEfficiencyPalette,
  /* 5 */ gasOilSaturationPalette,
  /* 6 */ gasOilSaturationPalette,
  /* 7 */ reserveDensityPalette,
  /* 8 */ reserveDensityPalette,
  /* 9 */ reserveDensityPalette,
  /* 10 */ reserveDensityPalette,
  /* 11 */ reserveDensityPalette,
  /* 12 */ reserveDensityPalette,
  /* 13 */ reserveDensityPalette,
  /* 14 */ reserveDensityPalette,
  /* 15 */ sandinessPalette,
]
